{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} ve {{ moreCount }} daha",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} ve {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} dosya",
  "{{ count }} files_other": "{{ count }} dosya",
  "{{ count }} people are typing_one": "{{ count }} kişi yazıyor",
  "{{ count }} people are typing_many": "{{ count }} kişi yazıyor",
  "{{ count }} people are typing_other": "{{ count }} kişi yazıyor",
  "{{ count }} photos_one": "{{ count }} fotoğraf",
  "{{ count }} photos_other": "{{ count }} fotoğraf",
  "{{ count }} reactions_one": "{{ count }} tepki",
  "{{ count }} reactions_other": "{{ count }} tepki",
  "{{ count }} videos_one": "{{ count }} video",
  "{{ count }} videos_other": "{{ count }} video",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} ve {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }} adet daha",
  "{{ memberCount }} members": "{{ memberCount }} üye",
  "{{ typing }} are typing": "{{ typing }} yazıyor",
  "{{ typing }} is typing": "{{ typing }} yazıyor",
  "{{ user }} has been muted": "{{ user }} sessize alındı",
  "{{ user }} has been unmuted": "{{ user }} sesi açıldı",
  "{{ user }} is typing...": "{{ user }} yazıyor...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} ve {{ user }} yazıyor...",
  "{{ users }} and more are typing...": "{{ users }} ve diğerleri yazıyor...",
  "{{ watcherCount }} online": "{{ watcherCount }} çevrimiçi",
  "{{count}} new messages_one": "{{count}} yeni mesaj",
  "{{count}} new messages_other": "{{count}} yeni mesaj",
  "{{count}} unread_one": "{{count}} okunmamış",
  "{{count}} unread_other": "{{count}} okunmamış",
  "{{count}} votes_one": "{{count}} oy",
  "{{count}} votes_other": "{{count}} oy",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} seçenek daha",
  "+{{count}} more options_other": "+{{count}} seçenek daha",
  "🏙 Attachment...": "🏙 Ek...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} oluşturdu: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} oy verdi: {{pollOptionText}}",
  "📍Shared location": "📍Paylaşılan konum",
  "Add a comment": "Yorum ekle",
  "Add a comment to your poll answer": "Anket yanıtınıza bir yorum ekleyin",
  "Add an option": "Bir seçenek ekle",
  "Add reaction": "Tepki ekle",
  "All results loaded": "Tüm sonuçlar yüklendi",
  "Allow access to camera": "Kameraya erişime izin ver",
  "Allow access to microphone": "Mikrofona erişime izin ver",
  "Allow comments": "Yorumlara izin ver",
  "Allow option suggestion": "Seçenek önerisine izin ver",
  "Allow others to add comments": "Diğerlerinin yorum eklemesine izin ver",
  "Also send as a direct message": "Ayrıca doğrudan mesaj olarak gönder",
  "Also send in channel": "Ayrıca kanala gönder",
  "Also sent in channel": "Kanala da gönderildi",
  "An error has occurred during recording": "Kayıt sırasında bir hata oluştu",
  "An error has occurred during the recording processing": "Kayıt işlemi sırasında bir hata oluştu",
  "Anonymous": "Anonim",
  "Anonymous poll": "Anonim anket",
  "Archive": "Arşivle",
  "Are you sure you want to delete this message?": "Bu mesajı silmek istediğinizden emin misiniz?",
  "aria/Attachment": "Ek",
  "aria/Attachment Actions": "Ek işlemleri",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Ses konumu {{ elapsed }} / {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Ses konumu yüzde {{ progress }}",
  "aria/Block User": "Kullanıcıyı engelle",
  "aria/Bookmark Message": "Mesajı yer imi ekle",
  "aria/Cancel recording": "Kaydı iptal et",
  "aria/Cancel Reply": "Cevabı İptal Et",
  "aria/Cancel upload": "Yüklemeyi İptal Et",
  "aria/Channel Actions": "Kanal işlemleri",
  "aria/Channel list": "Kanal listesi",
  "aria/Channel search results": "Kanal arama sonuçları",
  "aria/Chat view tabs": "Sohbet görünümü sekmeleri",
  "aria/Clear search": "Aramayı temizle",
  "aria/Close callout dialog": "Bilgi balonu iletişim kutusunu kapat",
  "aria/Close thread": "Konuyu kapat",
  "aria/Collapse sidebar": "Kenar çubuğunu daralt",
  "aria/Command Suggestions": "Komut önerileri",
  "aria/Complete recording": "Kaydı tamamla",
  "aria/Copy Message Text": "Mesaj metnini kopyala",
  "aria/Decrease value": "Değeri azalt",
  "aria/Delete Message": "Mesajı sil",
  "aria/Dismiss notification": "Bildirimi kapat",
  "aria/Download attachment": "Ek indir",
  "aria/Edit Message": "Mesajı Düzenle",
  "aria/Emoji picker": "Emoji seçici",
  "aria/Emoji Suggestions": "Emoji önerileri",
  "aria/Exit search": "Aramadan çık",
  "aria/Expand sidebar": "Kenar çubuğunu genişlet",
  "aria/File input": "Dosya girişi",
  "aria/File upload": "Dosya yükleme",
  "aria/Flag Message": "Mesajı bayrakla",
  "aria/Image failed to load": "Görsel yüklenemedi",
  "aria/Image input": "Resim girişi",
  "aria/Increase value": "Değeri artır",
  "aria/Jump to latest message": "En son mesaja git",
  "aria/Jump to quoted message": "Alıntılanan mesaja git",
  "aria/Load More Channels": "Daha Fazla Kanal Yükle",
  "aria/Mark Message Unread": "Okunmamış olarak işaretle",
  "aria/Mark messages as read": "Mesajları okundu olarak işaretle",
  "aria/Menu": "Menü",
  "aria/Message Actions": "Mesaj eylemleri",
  "aria/Message from {{ user }},": "{{ user }} adlı kullanıcıdan mesaj,",
  "aria/Message Options": "Mesaj Seçenekleri",
  "aria/Message,": "Mesaj,",
  "aria/Mute User": "Kullanıcıyı sustur",
  "aria/Notifications": "Bildirimler",
  "aria/Open Attachment Selector": "Ek Seçiciyi Aç",
  "aria/Open Channel Actions Menu": "Kanal işlemleri menüsünü aç",
  "aria/Open Menu": "Menüyü Aç",
  "aria/Open Message Actions Menu": "Mesaj İşlemleri Menüsünü Aç",
  "aria/Open Reaction Selector": "Tepki Seçiciyi Aç",
  "aria/Open Thread": "Konuyu Aç",
  "aria/Pause": "Duraklat",
  "aria/Pause recording": "Kaydı duraklat",
  "aria/Percent complete": "Yüzde {{percent}} tamamlandı",
  "aria/Pin Message": "Mesajı sabitle",
  "aria/Play": "Oynat",
  "aria/Quote Message": "Mesajı alıntıla",
  "aria/Reaction list": "Tepki listesi",
  "aria/Remind Me Message": "Hatırlat",
  "aria/Remind Me Options": "Hatırlatma seçenekleri",
  "aria/Remove attachment": "Eki kaldır",
  "aria/Remove location attachment": "Konum ekini kaldır",
  "aria/Remove option": "Seçeneği kaldır",
  "aria/Remove Reminder": "Hatırlatıcıyı kaldır",
  "aria/Remove Save For Later": "Sonraya kaydet'i kaldır",
  "aria/Resend Message": "Mesajı tekrar gönder",
  "aria/Resume recording": "Kaydı devam ettir",
  "aria/Retry upload": "Yüklemeyi Tekrar Dene",
  "aria/Review bounced message": "Geri dönen mesajı incele",
  "aria/Search results": "Arama sonuçları",
  "aria/Search results header filter button for: {{ source }}": "{{ source }} için arama sonuçları başlık filtre düğmesi",
  "aria/Seek audio position": "Ses konumunu ara",
  "aria/Select Channel: {{ channelName }}": "Kanal seç: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Tepki seç: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Kullanıcı kanalını seç: {{ name }}",
  "aria/Send": "Gönder",
  "aria/Show preview": "Önizlemeyi göster",
  "aria/Start recording audio": "Ses kaydını başlat",
  "aria/Stop AI Generation": "Yapay Zeka Üretimini Durdur",
  "aria/Suggestions": "Öneriler",
  "aria/Thread list": "İleti dizisi listesi",
  "aria/Unblock User": "Kullanıcının engelini kaldır",
  "aria/Unmute User": "Sesini aç",
  "aria/Unpin Message": "Sabitlemeyi kaldır",
  "aria/User Suggestions": "Kullanıcı önerileri",
  "Ask a question": "Bir soru sor",
  "Attach": "Ekle",
  "Attach files": "Dosya ekle",
  "Attachment": "Ek",
  "Attachment upload blocked due to {{reason}}": "{{reason}} nedeniyle ek yükleme engellendi",
  "Attachment upload failed due to {{reason}}": "{{reason}} nedeniyle ek yükleme başarısız oldu",
  "Back": "Geri",
  "ban-command-args": "[@kullanıcıadı] [metin]",
  "ban-command-description": "Bir kullanıcıyı yasakla",
  "Block User": "Kullanıcıyı engelle",
  "Cancel": "İptal",
  "Cannot seek in the recording": "Kayıtta arama yapılamıyor",
  "Channel archived": "Kanal arşivlendi",
  "Channel Missing": "Kanal bulunamıyor",
  "Channel muted": "Kanal sessize alındı",
  "Channel pinned": "Kanal sabitlendi",
  "Channel unarchived": "Kanal arşivden çıkarıldı",
  "Channel unmuted": "Kanal sesi açıldı",
  "Channel unpinned": "Kanal sabitlemesi kaldırıldı",
  "Channels": "Kanallar",
  "Chats": "Sohbetler",
  "Choose between 2 to 10 options": "2 ile 10 seçenek arasından seçin",
  "Close": "Kapat",
  "Close dialog": "İletişim kutusunu kapat",
  "Close emoji picker": "Emoji seçiciyi kapat",
  "Close prompt: {{ title }}": "İstemi kapat: {{ title }}",
  "Command not available while editing": "Düzenleme sırasında komut kullanılamaz",
  "Command not available while replying": "Yanıtlama sırasında komut kullanılamaz",
  "Commands": "Komutlar",
  "Commands matching": "Eşleşen komutlar",
  "Connection failure, reconnecting now...": "Bağlantı hatası, tekrar bağlanılıyor...",
  "Copy Message": "Mesajı kopyala",
  "Create": "Oluştur",
  "Create a question, add options, and configure poll settings": "Bir soru oluşturun, seçenekler ekleyin ve anket ayarlarını yapılandırın",
  "Create poll": "Anket oluştur",
  "Current location": "Mevcut konum",
  "Delete": "Sil",
  "Delete for me": "Benim için sil",
  "Delete message": "Mesajı sil",
  "Delivered": "İletildi",
  "Direct message": "Doğrudan mesaj",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "Bu anketi şimdi sonlandırmak istiyor musunuz? Sonlandırdıktan sonra bu ankette kimse oy kullanamayacak.",
  "Download All": "Tümünü indir",
  "Download Attachment": "Eki indir",
  "Download attachment {{ name }}": "Ek {{ name }}'i indir",
  "Drag your files here": "Dosyalarınızı buraya sürükleyin",
  "Drag your files here to add to your post": "Gönderinize eklemek için dosyalarınızı buraya sürükleyin",
  "Due {{ timeLeft }}": "{{ timeLeft }} içinde süresi dolacak",
  "Due since {{ dueSince }}": "{{ dueSince }}'den beri süresi dolmuş",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit Message": "Mesajı Düzenle",
  "Edit message request failed": "Mesaj düzenleme isteği başarısız oldu",
  "Edited": "Düzenlendi",
  "Emoji matching": "Emoji eşleştirme",
  "Empty message...": "Boş mesaj...",
  "End": "Son",
  "End poll": "Anketi sonlandır",
  "End this poll?": "Bu anketi sonlandır?",
  "End vote": "Oyu bitir",
  "Enforce unique vote is enabled": "Benzersiz oy etkinleştirildi",
  "Error": "Hata",
  "Error adding flag": "Bayrak eklenirken hata oluştu",
  "Error connecting to chat, refresh the page to try again.": "Bağlantı hatası, sayfayı yenileyip tekrar deneyin.",
  "Error deleting message": "Mesaj silinirken hata oluştu",
  "Error fetching reactions": "Reaksiyonlar alınırken hata oluştu",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Mesajı okunmamış olarak işaretleme hatası. En yeni 100 kanal mesajından daha eski okunmamış mesajları işaretleme yapılamaz.",
  "Error muting a user ...": "Kullanıcıyı sessize alırken hata oluştu ...",
  "Error pinning message": "Mesaj sabitlenirken hata oluştu",
  "Error removing message pin": "Mesaj PIN'i kaldırılırken hata oluştu",
  "Error reproducing the recording": "Kaydı yeniden üretme hatası",
  "Error starting recording": "Kayıt başlatılırken hata oluştu",
  "Error unmuting a user ...": "Kullanıcının sesini açarken hata oluştu ...",
  "Error uploading attachment": "Ek yüklenirken hata oluştu",
  "Error uploading file": "Dosya yüklenirken hata oluştu",
  "Error uploading image": "Resmi yüklerken hata",
  "Error: {{ errorMessage }}": "Hata: {{ errorMessage }}",
  "Exit command {{ command }}": "Komuttan çık {{ command }}",
  "Failed to block user": "Kullanıcı engellenemedi",
  "Failed to create the poll": "Anket oluşturulurken hata oluştu",
  "Failed to create the poll due to {{reason}}": "{{reason}} nedeniyle anket oluşturulamadı",
  "Failed to delete the message": "Mesaj silinemedi",
  "Failed to end the poll": "Anket sonlandırılamadı",
  "Failed to end the poll due to {{reason}}": "{{reason}} nedeniyle anket sonlandırılamadı",
  "Failed to jump to the first unread message": "İlk okunmamış mesaja atlamada hata oluştu",
  "Failed to leave channel": "Kanaldan çıkılamadı",
  "Failed to load channels": "Kanallar yüklenemedi",
  "Failed to load more channels": "Daha fazla kanal yüklenemedi",
  "Failed to mark channel as read": "Kanalı okundu olarak işaretleme başarısız oldu",
  "Failed to play the recording": "Kayıt oynatılamadı",
  "Failed to retrieve location": "Konum alınamadı",
  "Failed to share location": "Konum paylaşılamadı",
  "Failed to update channel archive status": "Kanalın arşiv durumu güncellenemedi",
  "Failed to update channel mute status": "Kanalın sessiz durumu güncellenemedi",
  "Failed to update channel pinned status": "Kanalın sabitleme durumu güncellenemedi",
  "File": "Dosya",
  "File is required for upload attachment": "Ek yüklemek için dosya gerekli",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "Dosya çok büyük: {{ size }}, maksimum yükleme boyutu {{ limit }}",
  "File too large": "Dosya çok büyük",
  "fileCount_one": "1 dosya",
  "fileCount_other": "{{ count }} dosya",
  "Flag": "Bayrak",
  "Generating...": "Oluşturuluyor...",
  "giphy-command-args": "[metin]",
  "giphy-command-description": "Rastgele bir gif'i kanala gönder",
  "Hide who voted": "Kimin oy verdiğini gizle",
  "Image": "Görsel",
  "imageCount_one": "Görsel",
  "imageCount_other": "{{ count }} görsel",
  "Instant commands": "Anlık komutlar",
  "language/af": "Afrikanca",
  "language/am": "Amharca",
  "language/ar": "Arapça",
  "language/az": "Azerice",
  "language/bg": "Bulgarca",
  "language/bn": "Bengalce",
  "language/bs": "Boşnakça",
  "language/cs": "Çekçe",
  "language/da": "Danca",
  "language/de": "Almanca",
  "language/el": "Yunanca",
  "language/en": "İngilizce",
  "language/es": "İspanyolca",
  "language/es-MX": "İspanyolca (Meksika)",
  "language/et": "Estonyaca",
  "language/fa": "Farsça",
  "language/fa-AF": "Darice",
  "language/fi": "Fince",
  "language/fr": "Fransızca",
  "language/fr-CA": "Fransızca (Kanada)",
  "language/ha": "Hausa",
  "language/he": "İbranice",
  "language/hi": "Hintçe",
  "language/hr": "Hırvatça",
  "language/ht": "Haiti Kreolcesi",
  "language/hu": "Macarca",
  "language/id": "Endonezce",
  "language/it": "İtalyanca",
  "language/ja": "Japonca",
  "language/ka": "Gürcüce",
  "language/ko": "Korece",
  "language/lt": "Litvanca",
  "language/lv": "Letonca",
  "language/ms": "Malayca",
  "language/nl": "Felemenkçe",
  "language/no": "Norveççe",
  "language/pl": "Lehçe",
  "language/ps": "Peştuca",
  "language/pt": "Portekizce",
  "language/ro": "Romence",
  "language/ru": "Rusça",
  "language/sk": "Slovakça",
  "language/sl": "Slovence",
  "language/so": "Somalice",
  "language/sq": "Arnavutça",
  "language/sr": "Sırpça",
  "language/sv": "İsveççe",
  "language/sw": "Svahilice",
  "language/ta": "Tamilce",
  "language/th": "Tayca",
  "language/tl": "Tagalogca",
  "language/tr": "Türkçe",
  "language/uk": "Ukraynaca",
  "language/ur": "Urduca",
  "language/vi": "Vietnamca",
  "language/zh": "Çince (basitleştirilmiş)",
  "language/zh-TW": "Çince (geleneksel)",
  "Leave Channel": "Kanaldan ayrıl",
  "Left channel": "Kanaldan ayrıldınız",
  "Let others add options": "Başkalarının seçenek eklemesine izin ver",
  "Limit votes per person": "Kişi başına oy sınırı",
  "Link": "Bağlantı",
  "linkCount_one": "Bağlantı",
  "linkCount_other": "{{ count }} bağlantı",
  "live": "canlı",
  "Live for {{duration}}": "{{duration}} boyunca canlı",
  "Live location": "Canlı konum",
  "Live until {{ timestamp }}": "{{ timestamp }}'e kadar canlı",
  "Load more": "Daha fazla yükle",
  "Local upload attachment missing local id": "Yerel yükleme ekinde yerel kimlik eksik",
  "Location": "Konum",
  "Location sharing ended": "Konum paylaşımı sona erdi",
  "Location: {{ coordinates }}": "Konum: {{ coordinates }}",
  "Mark as unread": "Okunmamış olarak işaretle",
  "Maximum number of votes (from 2 to 10)": "Maksimum oy sayısı (2 ile 10 arası)",
  "Maximum votes per person": "Kişi başına maksimum oy",
  "Menu": "Menü",
  "Message deleted": "Mesaj silindi",
  "Message failed to send": "Mesaj gönderilemedi",
  "Message has been successfully flagged": "Mesaj başarıyla bayraklandı",
  "Message marked as unread": "Mesaj okunmadı olarak işaretlendi",
  "Message pinned": "Mesaj sabitlendi",
  "Message unpinned": "Mesaj sabitlemesi kaldırıldı",
  "Message was blocked by moderation policies": "Mesaj moderasyon politikaları tarafından engellendi",
  "Messages have been marked unread.": "Mesajlar okunmamış olarak işaretlendi.",
  "Missing permissions to upload the attachment": "Ek yüklemek için izinler eksik",
  "Multiple votes": "Çoklu oy",
  "Mute": "Sessiz",
  "mute-command-args": "[@kullanıcıadı]",
  "mute-command-description": "Bir kullanıcının sesini kapat",
  "network error": "ağ hatası",
  "New": "Yeni",
  "New message from {{user}}": "{{user}} adlı kullanıcıdan yeni mesaj",
  "New Messages!": "Yeni Mesajlar!",
  "Next image": "Sonraki görsel",
  "No chats here yet…": "Henüz burada sohbet yok...",
  "No conversations yet": "Henüz konuşma yok",
  "No items exist": "Hiç öğe yok",
  "No results found": "Sonuç bulunamadı",
  "Nobody will be able to vote in this poll anymore.": "Artık bu ankette kimse oy kullanamayacak.",
  "Nothing yet...": "Şimdilik hiçbir şey...",
  "Offline": "Çevrimdışı",
  "Ok": "Tamam",
  "Online": "Çevrimiçi",
  "Only numbers are allowed": "Sadece sayılar kullanılabilir",
  "Only visible to you": "Sadece sana görünür",
  "Open emoji picker": "Emoji klavyesini aç",
  "Open gallery at image {{ index }}": "Galeriyi {{ index }}. görselde aç",
  "Open image in gallery": "Görseli galeride aç",
  "Open location in a map": "Konumu haritada aç",
  "Option already exists": "Seçenek zaten mevcut",
  "Option is empty": "Seçenek boş",
  "Options": "Seçenekler",
  "Original": "Orijinal",
  "People matching": "Eşleşen kişiler",
  "Photo": "Fotoğraf",
  "Pin": "Sabitle",
  "Pinned by {{ name }}": "{{ name }} sabitledi",
  "Pinned by You": "Sizin sabitlediğiniz",
  "placeholder/PollComment": "Yorumunuz",
  "placeholder/PollOptionSuggestion": "Yeni bir seçenek girin",
  "Play video": "Videoyu oynat",
  "Playback speed {{ rate }}x": "Oynatma hızı {{ rate }}x",
  "Poll": "Anket",
  "Poll comments": "Anket yorumları",
  "Poll ended": "Anket sonlandı",
  "Poll options": "Anket seçenekleri",
  "Poll results": "Anket sonuçları",
  "Previous image": "Önceki görsel",
  "Question": "Soru",
  "Question {{ optionOrderNumber}}": "Soru {{ optionOrderNumber}}",
  "Question is required": "Soru gereklidir",
  "Quote Reply": "Alıntıyla yanıtla",
  "Reached the vote limit. Remove an existing vote first.": "Oylama sınırına ulaşıldı. Önce mevcut bir oyu kaldırın.",
  "Recording format is not supported and cannot be reproduced": "Kayıt formatı desteklenmiyor ve çoğaltılamıyor",
  "Remind me": "Bana hatırlat",
  "Remind Me": "Hatırlat",
  "Reminder set": "Hatırlatıcı ayarlandı",
  "Remove reminder": "Hatırlatıcıyı kaldır",
  "Remove save for later": "Sonraya kaydet'i kaldır",
  "Replied to a thread": "Bir iş parçacığına yanıt verdi",
  "Reply": "Cevapla",
  "Reply to {{ authorName }}": "{{ authorName }} kişisine yanıt ver",
  "Reply to a message to start a thread": "Bir thread başlatmak için bir mesaja yanıt verin",
  "Reply to Message": "Mesaja Cevapla",
  "replyCount_one": "1 cevap",
  "replyCount_other": "{{ count }} cevap",
  "Resend": "Tekrar gönder",
  "Retry upload": "Yüklemeyi yeniden dene",
  "Review all options available in this poll": "Bu anketteki tüm mevcut seçenekleri inceleyin",
  "Review comments submitted with poll answers": "Anket yanıtlarıyla gönderilen yorumları inceleyin",
  "Review poll results and open an option to see detailed votes": "Anket sonuçlarını inceleyin ve ayrıntılı oyları görmek için bir seçenek açın",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Bu mesajı inceleyin ve silmeyi, düzenlemeyi veya yine de göndermeyi seçin",
  "Review who voted for this option": "Bu seçenek için kimlerin oy verdiğini inceleyin",
  "Save for later": "Daha sonra kaydet",
  "Saved for later": "Daha sonra kaydedildi",
  "Search": "Arama",
  "Search GIFs": "GIF ara",
  "search-results-header-filter-source-button-label--channels": "kanallar",
  "search-results-header-filter-source-button-label--messages": "mesajlar",
  "search-results-header-filter-source-button-label--users": "kullanıcılar",
  "Searching for {{ searchSourceType }}...": "{{ searchSourceType }} aranıyor...",
  "Searching...": "Aranıyor...",
  "searchResultsCount_one": "1 sonuç",
  "searchResultsCount_other": "{{ count }} sonuç",
  "Select a thread to continue the conversation": "Sohbeti sürdürmek için bir ileti dizisi seçin",
  "Select more than one option": "Birden fazla seçenek seçin",
  "Select one": "Birini seçin",
  "Select one or more": "Bir veya daha fazlasını seçin",
  "Select up to {{count}}_one": "En fazla {{count}}'yi seçin",
  "Select up to {{count}}_other": "En fazla {{count}}'yi seçin",
  "Select your current location and optionally enable live location sharing": "Mevcut konumunuzu seçin ve isteğe bağlı olarak canlı konum paylaşımını etkinleştirin",
  "Send": "Gönder",
  "Send a message": "Bir mesaj gönderin",
  "Send a message to start the conversation": "Sohbete başlamak için bir mesaj gönderin",
  "Send Anyway": "Yine de gönder",
  "Send message request failed": "Mesaj gönderme isteği başarısız oldu",
  "Send poll": "Anketi gönder",
  "Sending...": "Gönderiliyor...",
  "Sent": "Gönderildi",
  "Share": "Paylaş",
  "Share live location for": "Canlı konum paylaş",
  "Share Location": "Konum Paylaş",
  "Shared live location": "Paylaşılan canlı konum",
  "Shared location": "Paylaşılan konum",
  "Shuffle": "Karıştır",
  "size limit": "boyut sınırı",
  "Slow Mode ON": "Yavaş Mod Açık",
  "Slow mode, wait {{ seconds }}s...": "Yavaş mod, {{ seconds }} sn bekleyin...",
  "Some of the files will not be accepted": "Bazı dosyalar kabul edilmeyecek",
  "Start typing to search": "Aramak için yazmaya başlayın",
  "Stop sharing": "Paylaşımı durdur",
  "Submit": "Gönder",
  "Suggest a new option to add to this poll": "Bu ankete eklenecek yeni bir seçenek önerin",
  "Suggest an option": "Bir seçenek önerin",
  "Tap to remove": "Kaldırmak için dokunun",
  "Tap to remove: {{ reactionName }}": "Kaldırmak için dokunun: {{ reactionName }}",
  "Thinking...": "Düşünüyor...",
  "this content could not be displayed": "bu içerik gösterilemiyor",
  "This field cannot be empty or contain only spaces": "Bu alan boş olamaz veya sadece boşluk içeremez",
  "This message did not meet our content guidelines": "Bu mesaj içerik yönergelerimize uygun değil",
  "Thread": "Konu",
  "Thread has not been found": "Konu bulunamadı",
  "Thread reply": "Konu yanıtı",
  "Thread Reply": "Konu yanıtı",
  "ThreadListUnseenThreadsBanner/loading": "Yükleniyor...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} okunmamış ileti dizisi",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} okunmamış ileti dizisi",
  "Threads": "İleti dizileri",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Dün]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Bugün]\", \"nextDay\": \"[Yarın]\", \"lastDay\": \"[Dün]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[Geçen] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}d ago",
  "timestamp/relativeToday": "Bugün",
  "timestamp/relativeWeeksAgo": "{{ count }}w ago",
  "timestamp/relativeYesterday": "Dün",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Today] [at] HH:mm\", \"nextDay\": \"[Tomorrow] [at] HH:mm\", \"lastDay\": \"[Yesterday] [at] HH:mm\", \"nextWeek\": \"dddd [at] HH:mm\", \"lastWeek\": \"[Last] dddd [at] HH:mm\", \"sameElse\": \"ddd, D MMM [at] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "Kayıt yapmaya başlamak için tarayıcınızda kameraya erişime izin verin",
  "To start recording, allow the microphone access in your browser": "Kayıt yapmaya başlamak için tarayıcınızda mikrofona erişime izin verin",
  "totalVoteCount_one": "toplam 1 oy",
  "totalVoteCount_other": "toplam {{ count }} oy",
  "Translated": "Çevrildi",
  "Translated from {{ language }}": "{{ language }} dilinden çevrildi",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "2 ile 10 arasında bir sayı yazın",
  "Unarchive": "Arşivden çıkar",
  "unban-command-args": "[@kullanıcıadı]",
  "unban-command-description": "Bir kullanıcının yasağını kaldır",
  "Unblock User": "Kullanıcının engelini kaldır",
  "unknown error": "bilinmeyen hata",
  "Unmute": "Sesini aç",
  "unmute-command-args": "[@kullanıcıadı]",
  "unmute-command-description": "Bir kullanıcının sesini aç",
  "Unpin": "Sabitlemeyi kaldır",
  "Unread messages": "Okunmamış mesajlar",
  "Unsupported attachment": "Desteklenmeyen ek",
  "unsupported file type": "desteklenmeyen dosya türü",
  "Update": "Güncelle",
  "Update the comment attached to your poll answer": "Anket yanıtınıza ekli yorumu güncelleyin",
  "Update your comment": "Yorumunuzu güncelleyin",
  "Upload blocked": "Yükleme engellendi",
  "Upload error": "Yükleme hatası",
  "Upload failed": "Yükleme başarısız oldu",
  "Upload type: \"{{ type }}\" is not allowed": "Yükleme türü: \"{{ type }}\" izin verilmez",
  "User blocked": "Kullanıcı engellendi",
  "User unblocked": "Kullanıcının engeli kaldırıldı",
  "User uploaded content": "Kullanıcı tarafından yüklenen içerik",
  "Video": "Video",
  "videoCount_one": "Video",
  "videoCount_other": "{{ count }} video",
  "View": "Görüntüle",
  "View {{count}} comments_one": "{{count}} yorumu görüntüle",
  "View {{count}} comments_other": "{{count}} yorumu görüntüle",
  "View all": "Tümünü görüntüle",
  "View original": "Orijinali görüntüle",
  "View results": "Sonuçları görüntüle",
  "View translation": "Çeviriyi görüntüle",
  "Voice message": "Sesli mesaj",
  "Voice message {{ duration }}": "Sesli mesaj {{ duration }}",
  "Voice message deleted": "Sesli mesaj silindi",
  "voiceMessageCount_one": "Sesli mesaj",
  "voiceMessageCount_other": "{{ count }} sesli mesaj",
  "Vote ended": "Oylama sona erdi",
  "Votes": "Oylar",
  "Wait until all attachments have uploaded": "Tüm ekler yüklenene kadar bekleyin",
  "Waiting for network…": "Ağ bekleniyor…",
  "You": "Sen",
  "You've reached the maximum number of files": "Maksimum dosya sayısına ulaştınız"
}
